import type {
  MotorLeadExtensionsQueryVariables,
  Motor_Lead_Extensions_Bool_Exp
} from "gql/api";
import { Order_By } from "gql/api";

export function restoreMotorLeadExtensions(
  arr: Array<string>
): Motor_Lead_Extensions_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function deleteMotorLeadExtensions(
  arr: Array<string>
): Motor_Lead_Extensions_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export const defaultMleVars: MotorLeadExtensionsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { series: Order_By.Asc }
  ]
};

export const adminMleVars: MotorLeadExtensionsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { series: Order_By.Asc }
  ]
};
export const kocMleVars: MotorLeadExtensionsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { series: Order_By.Asc }
  ],
  where: {
    _or: [
      { include_koc_timestamp: { _is_null: false } },
      { only_koc_timestamp: { _is_null: false } }
    ]
  }
};

export const ecopetrolMleVars: MotorLeadExtensionsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { series: Order_By.Asc }
  ],
  where: {
    _or: [
      { include_ecopetrol_timestamp: { _is_null: false } },
      { only_ecopetrol_timestamp: { _is_null: false } }
    ]
  }
};
